<script>
export default {
    computed: {
        activeFilters() {
            return this.props.filters.filter(filter => {
                if (filter.type === 'search' || filter.location === 'header') {
                    return false;
                } else if (filter.type === 'date') {
                    return (
                        filter.current_value.startDate ||
                        filter.current_value.endDate
                    );
                } else if (filter.type === 'list' && filter.checklist) {
                    return (
                        filter.current_value.length !== filter.options.length
                    );
                } else if (filter.show_as_active_value !== null) {
                    return filter.current_value === filter.show_as_active_value;
                } else if (filter.current_value !== filter.inactive_value) {
                    return true;
                    // } else if (filter.current_value || filter.current_value === 0) {
                    //     return true;
                } else {
                    return false;
                }
            });
        },
        hasActiveFilters() {
            return this.activeFilters.length > 0;
        },
    },
};
</script>
